import React from 'react';

const Overview = () => {
    return (
        <section id="overview" className="overview-section bg-dark-gray">
            <div className="flex items-center object-contain mt-4" style={{ height: '30vh' }}></div>
            <div className="flex items-center bg-dark-gray">
              <div className="text-center mt-4">
                <h1 className="font-bold text-2xl mb-2">Hello, I'm Hasan Omarzae</h1>
                <p className="text-gray-300">Software Engineer | MSc Computer Science, NTNU</p>
                <p className="text-gray-400 text-sm mt-1">Atlanta, Georgia</p>
              </div>
            </div>
            <a href="#about-me" className="scroll-to-about-me-button text-gray-400 hover:text-white transition duration-300">
                &#8595; Learn more
            </a>
        </section>
    );
};

export default Overview;
